// material
import { alpha, styled } from '@mui/material/styles';
import { Card, Typography } from '@mui/material';
// utils
import { fShortenNumber } from '../utils/formatNumber';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  position: 'relative',
  overflow: 'hidden',
  padding: theme.spacing(2),
  borderRadius: '12px',
  background: `linear-gradient(135deg, ${alpha(theme.palette.secondary.main, 0.08)} 0%, ${alpha(theme.palette.secondary.light, 0.04)} 100%)`,
  border: 'none',
  boxShadow: `0 2px 8px ${alpha(theme.palette.secondary.main, 0.12)}`,
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'translateY(-3px)',
    boxShadow: `0 6px 16px ${alpha(theme.palette.secondary.main, 0.2)}`,
  },
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '3px',
    background: `linear-gradient(90deg, ${theme.palette.secondary.main} 0%, ${theme.palette.secondary.light} 100%)`,
  },
}));
// ----------------------------------------------------------------------

export default function AveUnitTrans(props) {
  const { trans, unit } = props;
  const ave = unit / trans;
  return (
    <RootStyle>
      <Typography
        variant="subtitle2"
        sx={{
          color: (theme) => theme.palette.secondary.dark,
          fontWeight: 600,
          mb: 0.8,
          fontSize: '0.7rem',
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
          opacity: 0.9,
        }}
      >
        Units/Transaction
      </Typography>
      <Typography
        variant="h5"
        sx={{
          color: (theme) => theme.palette.secondary.main,
          fontWeight: 700,
          fontSize: '1.3rem',
        }}
      >
        {fShortenNumber(ave)}
      </Typography>
    </RootStyle>
  );
}
